import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-dates/lib/css/_datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/react-virtualized.css';
import '../styles/style';
import '../styles/react-dates-overwrite';
import '../styles/react-select-overwrite';
import '../styles/bootstrap-overwrite';



// WEBPACK FOOTER //
// ./src/boot/css.ts